import styled from 'styled-components';

import {
  ThemeProps as Prop, Components, FontFamily, FontSize,
} from '@powdr/constants';
import { getFontStyles, themeUtil } from '@powdr/utils';

const CPNT = Components.DOR_TRAFFIC_SIGNS;

export const StyledDorTrafficSigns = styled.div`
`;

export const Title = styled.h3`
/*   ${() => getFontStyles(FontFamily.PRIMARY_FONT, FontSize.LRG10, undefined, undefined, Components.WYSIWYG, 'header3')};
  color: ${({ $colorProfile }) => themeUtil(Prop.HEADER, CPNT, $colorProfile)}; */
  margin-bottom: 25px;
`;
